import { render, staticRenderFns } from "./CheckboxGroup.vue?vue&type=template&id=64b7e10e&scoped=true"
import script from "./CheckboxGroup.vue?vue&type=script&lang=ts"
export * from "./CheckboxGroup.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxGroup.vue?vue&type=style&index=0&id=64b7e10e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7e10e",
  null
  
)

export default component.exports